import {
  openPackingCam,
  promptRecordTracking,
  promptVerifyShipping,
  openShippingLabel
} from './postScanModules';

export function createPostScanDriver(config) {
  const driver = {
    // A workflow whose packing cam hand-off is not route-param based supplies
    // its own (ScanPack drives it from pipeline state).
    openPackingCam: config.openPackingCam || (params => openPackingCam(config, params)),
    promptRecordTracking: params => promptRecordTracking(config, params),
    promptVerifyShipping: params => promptVerifyShipping(config, params),
    finalize: config.finalize
  };

  if (config.reScanOrderItems) {
    driver.reScanOrderItems = config.reScanOrderItems;
  }

  if (config.shippingLabel) {
    driver.openShippingLabel = params => openShippingLabel(config, params);
  }

  if (config.runStep) {
    driver.runStep = config.runStep;
  }

  return driver;
}
